/* eslint-disable no-restricted-syntax */
import { PermissionToEntitiesMap } from '@amzn/coral_com-amazon-carrierlogisticswebserver-model';
import { ENTITY_FILTER_ENUMS } from '../constants/authorization';

export const mapPermissionsToTerms = (
  permissionEntities: PermissionToEntitiesMap
) => {
  const result: { [key: string]: any } = {};
  for (const [permission, entityList] of Object.entries(permissionEntities)) {
    for (const [filter, entity] of Object.entries(entityList)) {
      const existingMap = result[permission] ?? [];
      result[permission] = existingMap.concat(
        entity.map(({ lpId, term }) =>
          filter === ENTITY_FILTER_ENUMS.LP ? lpId : term
        )
      );
    }
  }
  return updateKeysWithValues(result);
};

const updateKeysWithValues = (entity) => {
  const result = {};
  for (const [permission, terms] of Object.entries(entity)) {
    terms.forEach((term) => {
      const existingPermissions = result[term] ?? [];
      result[term] = [...existingPermissions, permission];
    });
  }
  return result;
};
